import TeamRanking from './TeamRanking';

export default TeamRanking;
